var _path, _path2, _polygon, _polygon2, _circle, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _ellipse, _path3, _rect9, _rect10, _rect11, _rect12, _path4, _path5, _path6, _line, _line2, _line3, _path7, _rect13, _rect14, _rect15, _rect16, _rect17, _rect18, _rect19, _rect20, _rect21, _rect22, _rect23, _rect24, _path8, _rect25, _path9, _path10, _path11, _path12, _path13, _ellipse2, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _circle2, _circle3, _path24, _path25, _path26, _path27, _polygon3, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _polygon4, _path35, _polygon5, _path36, _path37, _path38, _ellipse3, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _rect26, _path56, _path57, _rect27, _rect28, _rect29, _rect30, _circle4, _rect31, _circle5, _rect32, _rect33, _circle6, _circle7, _rect34, _g, _g2, _rect35, _g3, _ellipse4, _polygon6, _polygon7, _path58, _ellipse5, _path59, _path60;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgProfessionalDancer(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 865.76,
    height: 682.89,
    viewBox: "0 0 865.76 682.89",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M777.28,201.36S663.33,76.81,489.33,34.46s-199.62,96.29-249.09,151S100.67,234.06,56.51,301.17,60.93,486.66,277.33,516.7,480.5,431,614.75,452.22,903.6,359.47,777.28,201.36Z",
    fill: "#2b1df7"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M777.28,201.36S663.33,76.81,489.33,34.46s-199.62,96.29-249.09,151S100.67,234.06,56.51,301.17,60.93,486.66,277.33,516.7,480.5,431,614.75,452.22,903.6,359.47,777.28,201.36Z",
    fill: "#fff",
    opacity: 0.7,
    style: {
      isolation: "isolate"
    }
  }), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M62.52,196.06V562.18H210V196.06Zm136,355.59H74.07v-345h124.4Z",
    fill: "#2f2e41"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "99.29 239.22 89.79 239.22 85.05 272.97 104.02 272.97 99.29 239.22",
    fill: "#d1d3d4"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "100.79 229.94 88.29 229.94 89.73 239.49 99.34 239.49 100.79 229.94",
    fill: "#d1d3d4"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 125.44,
    cy: 258.69,
    r: 15.43,
    fill: "#e6e7e8"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 142.88,
    y: 322.28,
    width: 49.54,
    height: 50.55,
    fill: "#e6e7e8"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 151.48,
    y: 331.06,
    width: 32.34,
    height: 33,
    fill: "#fff"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 75.48,
    y: 326.37,
    width: 12.26,
    height: 45.96,
    fill: "#e6e7e8"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 88.24,
    y: 326.37,
    width: 12.26,
    height: 45.96,
    fill: "#d1d3d4"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 105.61,
    y: 326.32,
    width: 12.26,
    height: 45.96,
    transform: "translate(-64.54 27.71) rotate(-10.99)",
    fill: "#e6e7e8"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 183.63,
    y: 505.55,
    width: 12.26,
    height: 45.96,
    fill: "#e6e7e8"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 170.89,
    y: 505.55,
    width: 12.26,
    height: 45.96,
    fill: "#d1d3d4"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 136.69,
    y: 522.37,
    width: 45.96,
    height: 12.26,
    transform: "translate(-389.57 584.49) rotate(-79.01)",
    fill: "#e6e7e8"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 137.51,
    cy: 447.98,
    rx: 14.77,
    ry: 23.37,
    fill: "#2b1df7"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M143.29,420.07c.46-4.18,4.17-20.37,4.17-20.37H127.54s3.71,16.19,4.17,20.37a13.77,13.77,0,0,1-1.86,7.86l7.65,6.73,7.63-6.73A13.69,13.69,0,0,1,143.29,420.07Z",
    fill: "#e6e7e8"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 74.07,
    y: 273.63,
    width: 124.41,
    height: 13.44,
    fill: "#2f2e41"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 74.07,
    y: 372.85,
    width: 124.41,
    height: 13.44,
    fill: "#2f2e41"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 74.07,
    y: 472.05,
    width: 124.41,
    height: 13.44,
    fill: "#2f2e41"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 372.95,
    y: 139.62,
    width: 215.85,
    height: 307.96,
    fill: "#fff",
    opacity: 0.43
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M449.86,245.14a.49.49,0,0,1-.35-.84l52.83-52.86a.49.49,0,1,1,.7.7L450.2,245A.49.49,0,0,1,449.86,245.14Z",
    fill: "#2f2e41"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M508,187a.5.5,0,0,1-.35-.84L530,163.83a.49.49,0,0,1,.69,0,.48.48,0,0,1,0,.7l-22.32,22.32A.49.49,0,0,1,508,187Z",
    fill: "#2f2e41"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M435.17,241a.5.5,0,0,1-.35-.84l31.71-31.73a.49.49,0,0,1,.69,0,.5.5,0,0,1,0,.7l-31.7,31.72A.5.5,0,0,1,435.17,241Z",
    fill: "#2f2e41"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 459.24,
    y1: 417.3,
    x2: 449.86,
    y2: 426.7,
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 530.31,
    y1: 346.23,
    x2: 464.52,
    y2: 412.01,
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 466.87,
    y1: 390.86,
    x2: 435.17,
    y2: 422.59,
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M488,306.53a7.15,7.15,0,1,0-7.15,7.17A7.15,7.15,0,0,0,488,306.53Z",
    fill: "#2f2e41"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 372.95,
    y: 305.44,
    width: 214.31,
    height: 13.14,
    fill: "#2f2e41"
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 356.11,
    y: 111.75,
    width: 249.42,
    height: 27.87,
    fill: "#2f2e41"
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 356.11,
    y: 447.58,
    width: 249.42,
    height: 27.87,
    fill: "#2f2e41"
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    x: 266.92,
    y: 72.74,
    width: 426.38,
    height: 8.36,
    fill: "#2f2e41"
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    x: 282.26,
    y: 65.77,
    width: 23.7,
    height: 440.32,
    rx: 8.79,
    fill: "#d1d3d4"
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    x: 304.54,
    y: 65.77,
    width: 23.7,
    height: 440.32,
    rx: 8.79,
    fill: "#e6e7e8"
  })), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    x: 326.83,
    y: 65.77,
    width: 23.7,
    height: 440.32,
    rx: 8.79,
    fill: "#d1d3d4"
  })), _rect20 || (_rect20 = /*#__PURE__*/React.createElement("rect", {
    x: 349.14,
    y: 65.77,
    width: 23.7,
    height: 440.32,
    rx: 8.79,
    fill: "#e6e7e8"
  })), _rect21 || (_rect21 = /*#__PURE__*/React.createElement("rect", {
    x: 588.8,
    y: 65.77,
    width: 23.7,
    height: 440.32,
    rx: 8.79,
    fill: "#e6e7e8"
  })), _rect22 || (_rect22 = /*#__PURE__*/React.createElement("rect", {
    x: 611.09,
    y: 65.77,
    width: 23.7,
    height: 440.32,
    rx: 8.79,
    fill: "#d1d3d4"
  })), _rect23 || (_rect23 = /*#__PURE__*/React.createElement("rect", {
    x: 633.4,
    y: 65.77,
    width: 23.7,
    height: 440.32,
    rx: 8.79,
    fill: "#e6e7e8"
  })), _rect24 || (_rect24 = /*#__PURE__*/React.createElement("rect", {
    x: 655.68,
    y: 65.77,
    width: 23.7,
    height: 440.32,
    rx: 8.79,
    fill: "#d1d3d4"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M746,426.85H650V412.07a5.73,5.73,0,0,1,5.72-5.72h84.57a5.72,5.72,0,0,1,5.71,5.72Zm-94-2h92V412.07a3.72,3.72,0,0,0-3.71-3.72H655.76a3.73,3.73,0,0,0-3.72,3.72Z",
    fill: "#2f2e41"
  })), _rect25 || (_rect25 = /*#__PURE__*/React.createElement("rect", {
    x: 687.73,
    y: 408.6,
    width: 102.64,
    height: 1,
    transform: "matrix(0.95, -0.3, 0.3, 0.95, -88.13, 237.81)",
    fill: "#2b1df7"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M628,547.35l-10.72,82.93a1.84,1.84,0,0,0,1.83,2.07h0a1.85,1.85,0,0,0,1.8-1.45L639,547.35Z",
    fill: "#2f2e41"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M763.31,547.35,774,630.28a1.84,1.84,0,0,1-1.83,2.07h0a1.85,1.85,0,0,1-1.8-1.45l-18.1-83.55Z",
    fill: "#2f2e41"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M538.85,236.93l-25.55-9.42a32.12,32.12,0,0,1-13.87-9.93c-10.08-12.42-30.6-38.66-37.3-54.28,0,0-5-6-3-16,0,0,1-3-2-7l-3.63-5.81a1.66,1.66,0,0,0-2.8,0h0a1.65,1.65,0,0,0-.07,1.74l4,7.16a1.44,1.44,0,0,1-.24,1.71h0a1.44,1.44,0,0,1-2.21-.22l-6.1-9.15a1.38,1.38,0,0,0-2.12-.21h0a1.38,1.38,0,0,0-.15,1.76l8,11.58a1,1,0,0,1,.07,1h0a1,1,0,0,1-1.67.11l-5.77-8.48a1.2,1.2,0,0,0-2.08.29h0a1.18,1.18,0,0,0,.11,1.08l7.12,9.74a.77.77,0,0,1-.28,1.16l-.59.3a.79.79,0,0,1-1-.22l-4.22-5.43a1.26,1.26,0,0,0-2.17.34h0a1.23,1.23,0,0,0,.14,1.13l4.8,7.21a6,6,0,0,1,1,2.41,13.08,13.08,0,0,0,4.74,8,6.38,6.38,0,0,1,1.78,2.31c3.31,7.57,18.92,42.54,31.36,58.54,0,0,9,14,21,20l24,14.93A146,146,0,0,0,538.85,236.93Z",
    fill: "#f9b499"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M580.65,202.86s-4.52,26.44-11.52,43.44l9,26,19-41-6-32Z",
    fill: "#2f2e41"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M580.65,202.86s-4.52,26.44-11.52,43.44l9,26,19-41-6-32Z",
    opacity: 0.2
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 601.25,
    cy: 214.71,
    rx: 27.05,
    ry: 19.86,
    transform: "translate(245.67 744.96) rotate(-75.81)",
    fill: "#f9b499"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M578.13,202.3l9,2,4-5v5s13,3,17,4l2.5-4.5v5.42l3.5,1.08,3-3v4.64s5,1.65,4.47,4c0,0-2.77,16.57-14.62,23a88,88,0,0,1-8.85,26.4l-50,93s4,5,34,13l13-14v20a214.17,214.17,0,0,0,47,5s-8-48-5-79c0,0,11-70-1-102,0,0-7-20-31-20C605.13,181.3,586.13,181.3,578.13,202.3Z",
    fill: "#2f2e41"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M315.21,391.83S325,453.35,320,494.35c0,0-1,10-12,26l-44,65s-10-6-14-9l13-35s14.42-31.21,22.71-43.6c0,0,8.52-8.09-2.09-47.24l-3.12-52.18,32.2-9.61Z",
    fill: "#f7a48b"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M237,325.35l1,18s50.5,2.5,58.5-1.35l1.21-23.16S284,323.35,237,325.35Z",
    fill: "#f9b499"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M237,325.35l1,18h9s39.39-16,50.68-24.51C297.75,318.84,275,324.35,237,325.35Z",
    fill: "#f7a48b"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M183.21,266.57l-20.33,13.8A21.52,21.52,0,0,1,152.56,284a276.85,276.85,0,0,1-47.59-.62L88,282.35A41.28,41.28,0,0,1,74.13,277a19.11,19.11,0,0,1-2.46-1.92c-.79-.69-2.63-1.72-6.63-1.72,0,0-9-1-7,1a13.71,13.71,0,0,0,9,2.14.93.93,0,0,1,1,.93h0a.92.92,0,0,1-.92.94c-3.1,0-12.92.31-12.08,2,0,0,0,2,11,1,0,0,4-1,4,1,0,0,0,2-4,1,0,0-9-1-8,2,0,0,0,1,7,1,0,0,6-1,6,1,0,0,1,1-4,1,0,0-6-1-5,1,0,0,0,3,12,1a16.08,16.08,0,0,0,12,1s36,6,63,9c0,0,15,3,25-2l17.76-7.16Z",
    fill: "#f9b499"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M327,238h23.6s9.88,1.55,23.14-5l42.6-27.5A3.4,3.4,0,0,0,418,202.5c0-3.39.35-10.66,4.08-15.15l4-4a9.19,9.19,0,0,1,4.86-2.55l6.6-1.2a.83.83,0,0,1,.8,1.34c-.84,1-2.59,2.33-6.23,3.37,0,0-6,4-5,6,0,0,1,0,3-2a9.93,9.93,0,0,1,2.39-2.44A1,1,0,0,1,434,187c-.35,1.24-1.34,3.27-3.91,6.35a24.13,24.13,0,0,0-3,8,27.33,27.33,0,0,1-9,16l-37.07,33s-8.93,10-30.93,10L327,262Z",
    fill: "#f9b499"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M327,237.53v31.28a5.14,5.14,0,0,1-3.31,4.81L306,280.35l-.92,33.36a4.08,4.08,0,0,1-2.66,3.73c-17,6.12-65.42,7.91-65.42,7.91l-15-30-26,8-15-43,35-19c.91-.44,1.84-.86,2.78-1.26,28.91-12.56,69.67-9.91,69.67-9.91q4.31.25,8,.53h0c15.55,1.16,23.78,2.51,27.64,3.3A3.58,3.58,0,0,1,327,237.53Z",
    fill: "#2b1df7"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M296.54,230.72C291,262.09,263,278.35,263,278.35c-15.82-2-43.58-37.44-44.22-38.26,28.91-12.56,69.67-9.91,69.67-9.91q4.31.25,8,.53Z",
    fill: "#fff",
    opacity: 0.2
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M629.06,305.31,562.79,348.7l-14.66,9.6c-22-14-43-40-43-40,2.1-3.67,4.47-8.38,6.83-13.33,6.64-13.9,13.17-29.67,13.17-29.67,9.15-20.6,13.07-35.37,14.41-41.22a2.37,2.37,0,0,1,3.27-1.62c25.49,11.32,55.75,32,55.75,32,19.79,16.7,28.5,29.54,31.82,35.39A4.12,4.12,0,0,1,629.06,305.31Z",
    fill: "#2b1df7"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M564,243.16s-16.38,32.56,15.89,34.35c0,0,6.89,26.33,38.09,5.56l-11-11.16a17.24,17.24,0,0,1-13.21,5.85,19.54,19.54,0,0,1-18.12-13.24,23.8,23.8,0,0,1-.1-14.66Z",
    fill: "#fff",
    opacity: 0.2
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 571.68,
    cy: 284.77,
    r: 3.47,
    fill: "#2f2e41"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 562.76,
    cy: 294.68,
    r: 3.47,
    fill: "#2f2e41"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M547.39,325.91c19.21,2.76,39-3.27,54.54-14.57,1.05-.81,3.71-2.82,4.79-3.63-1,.91-3.55,3.07-4.56,3.93-15.07,12.1-35.64,18.34-54.77,14.27Z",
    opacity: 0.2
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M558.13,332.3c3.66-.12,7.38-.54,11-1a13.81,13.81,0,0,1-11,1Z",
    opacity: 0.2
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M562.79,348.7l-14.66,9.6c-22-14-43-40-43-40,2.1-3.67,4.47-8.38,6.83-13.33C521.34,313.9,545.93,336.87,562.79,348.7Z",
    fill: "#fff",
    opacity: 0.2
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M716.8,366.68h0a19.93,19.93,0,0,1,9.36-3.65c12.06-1.32,18.27,5.45,20.25,8.17a1.52,1.52,0,0,1-.15,2h0a1.52,1.52,0,0,1-2.17,0,16,16,0,0,0-8.94-4.75,19.81,19.81,0,0,1-2.29-.48c-2.21-.58-2.9,0-3,.76a1.57,1.57,0,0,0,1.41,1.75c8.65,1,5.88,2.88,5.88,2.88-.62,1.25-3.21.93-5.06.52a13.49,13.49,0,0,0-5.93-.08,14.2,14.2,0,0,0-4,1.56c-4,2.38-8.32,2.59-13,2.17a50.06,50.06,0,0,1-7-1.17,283.8,283.8,0,0,1-49-10c-16-5-22.21-15.08-22.21-15.08l-26-30.09,22.35-14.63,17.88,28.8s5,11,26,18l37.79,14.39A8.43,8.43,0,0,0,716.8,366.68Z",
    fill: "#f9b499"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    points: "604.9 321.13 610.19 327.25 632.68 315.25 627.25 306.5 604.9 321.13",
    fill: "#f7a48b"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M560.92,417.92c-12.87,17.74-24.79,8.38-24.79,8.38a17,17,0,0,0-5-2.32,49,49,0,0,0-8-1.68c-24,3-26.89-17.5-26.89-17.5a16.46,16.46,0,0,0-4.91-6.84c-6.37-5.24-15.2-4.66-15.2-4.66-8.51,1-14-1.2-17.56-4.58-6.87-6.55-6.44-17.42-6.44-17.42,0-6-4-14-4-14l-9.92-12.76a4.52,4.52,0,0,1,2.29-7.12l64.63-19.12c19.41,22.55,43,40,43,40-3.29,25.52,8.66,47.71,13,54.77A4.37,4.37,0,0,1,560.92,417.92Z",
    fill: "#2f2e41"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M560.92,417.92c-12.87,17.74-24.79,8.38-24.79,8.38a17,17,0,0,0-5-2.32,49,49,0,0,0-8-1.68c-24,3-26.89-17.5-26.89-17.5a16.46,16.46,0,0,0-4.91-6.84c-6.37-5.24-15.2-4.66-15.2-4.66-8.51,1-14-1.2-17.56-4.58-6.87-6.55-6.44-17.42-6.44-17.42,0-6-4-14-4-14l-9.92-12.76a4.52,4.52,0,0,1,2.29-7.12l64.63-19.12c19.41,22.55,43,40,43,40-3.29,25.52,8.66,47.71,13,54.77A4.37,4.37,0,0,1,560.92,417.92Z",
    opacity: 0.2
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M505.13,327.25c-14.18,12.54-32,20.86-50.31,25.23l-3.69.82c19.33-5.44,38-13.76,54-26.05Z",
    opacity: 0.2
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M515.13,333.3c-9.37,16.22-26,41.35-42,51l3.34-2.48c7.35-6.27,13.63-13.76,19.49-21.41,6.78-8.75,13.05-17.89,19.17-27.11Z",
    opacity: 0.2
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M526.13,343.3c-5.15,20.47-12,43.71-18,64,5-21.6,11.28-42.89,18-64Z",
    opacity: 0.2
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M538.85,351.69c-1.59,21.79-3,43.79-.6,65.56l.6,4.34c-2.22-10-2.78-20.34-2.81-30.55a275.64,275.64,0,0,1,2.81-39.35Z",
    opacity: 0.2
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M509,510.43c9,17.83,22.14,76.87,22.14,76.87l-14,7-41-92.83c-6-11.82,0-30.17,0-30.17L491.32,398h0a16.46,16.46,0,0,1,4.91,6.84s2.89,20.5,26.89,17.5a49,49,0,0,1,8,1.68l-25,59.32c-3.47,6.94-1.16,16.56.58,21.79A39.86,39.86,0,0,0,509,510.43Z",
    fill: "#f7a48b"
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    points: "517.13 594.3 528.13 617.3 535.15 617.3 535.15 603.46 531.13 587.3 517.13 594.3",
    fill: "#e6e6e6"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M527.13,629.3s-5-13,1-12c0,0,6-1,5-7,0,0,0-11,4-6a114.42,114.42,0,0,1,11,30l-2,1s-7-15-6-3l1,10s1,5.81-4.47,5.9L513,650.14a1.83,1.83,0,0,1-2-1.92c.15-2.65,1.55-6.92,9.13-6.92C520.13,641.3,530.13,641.3,527.13,629.3Z",
    fill: "#2b1df7"
  })), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    points: "475.13 579.3 482.11 601.3 489.13 601.3 489.13 587.46 488.13 573.3 475.13 579.3",
    fill: "#e6e6e6"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M481.11,613.3s-5-13,1-12c0,0,6-1,5-7,0,0,0-11,4-6a114.42,114.42,0,0,1,11,30l-2,1s-7-15-6-3l1,10s1.05,5.81-4.48,5.9L467,634.14a1.83,1.83,0,0,1-2-1.92c.14-2.65,1.55-6.92,9.13-6.92C474.11,625.3,484.11,625.3,481.11,613.3Z",
    fill: "#2b1df7"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M470.63,496.13c10.5,17.83,17.5,77.17,17.5,77.17l-13,6-32-86c-11-23-3-37-3-37l18.44-67.58c3.55,3.38,9.05,5.6,17.56,4.58,0,0,8.83-.58,15.2,4.66l-9.87,47.61L470.13,465.3C462.13,479.3,470.63,496.13,470.63,496.13Z",
    fill: "#f9b499"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M627.17,219c11-27.34-8.49-35.16-8.49-35.16,15.55-.49,23.45-9.41,23.45-9.41-23-5.91-29,4.91-29,4.91-4-19-20-24-20-24-1,9,9.91,23.34,9.91,23.34-18.1,3.34-22.12,17.83-22.12,17.83s8.65-16.24,29.51-10.26A18.62,18.62,0,0,1,622.15,196c2.1,4.4,3.71,10.94,2.7,20.21l1.24.93Z",
    fill: "#2b1df7"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 267.56,
    cy: 205.41,
    rx: 28.12,
    ry: 19.86,
    transform: "translate(17.6 431.91) rotate(-79.69)",
    fill: "#f9b499"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M249.3,220.28l-5.17,29s12,12,22,3v-19S255.54,234.85,249.3,220.28Z",
    fill: "#f9b499"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M249.3,220.28s-1.17,19.6,16.83,19.81v-6.83S255.46,235.27,249.3,220.28Z",
    fill: "#f7a48b"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M282.13,279.3c8.31,8.94,1,12,1,12-1.83,1.83-1.05,3.29-.16,4.15a11.4,11.4,0,0,1,3,4.65c1.44,4.54-1.86,5.2-1.86,5.2-7,1-5-7-5-7-1-6-3-6-3-6-3.6-1.45-3.05-4.45-2.46-6a8.42,8.42,0,0,0,.52-4.24,6.85,6.85,0,0,0-2-4,11.85,11.85,0,0,1-2.95-4.17c-1.81-4.6.89-6.62.89-6.62a6.34,6.34,0,0,0,1.1-5.62,6,6,0,0,0-2.18-3.07c-2.92-2.26-2.92-6.31-2.92-6.31v-19c10.41-1.41,16.59-12.18,16.59-12.18a41.4,41.4,0,0,0,3.69-28.78c-5.73,14-28.28,6-28.28,6-3,8-5.08,5.39-5.08,5.39l-4.92-.89c-1.59,11,1.17,17.48,1.17,17.48l-1.93,10.84s-24.24-40.82-5.24-55.82c0,0,13.3-16.43,35-14.69a27.41,27.41,0,0,1,19.42,10.18c4.48,5.69,8.49,14.73,7.54,28.51,0,0-1,14.52-18.55,40.79a35.37,35.37,0,0,0-6.7,9.65A15.09,15.09,0,0,0,280.3,264a8.15,8.15,0,0,1,.74,8.35S280.22,277.24,282.13,279.3Z",
    fill: "#2f2e41"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M218.82,271.46c1.08,8,1,16.14,3.22,23.89-2-3.56-2.52-7.75-3-11.75a70.34,70.34,0,0,1-.21-12.14Z",
    opacity: 0.2
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M212,280.35c2.73,5.23,4.9,10.72,8.39,15.5-4.56-3.87-7-9.81-8.39-15.5Z",
    opacity: 0.2
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M308,250.35a97.8,97.8,0,0,1,.52,15.11c-.28,5-.66,10.18-2.52,14.89.12-.62.25-1.23.39-1.84,1.41-9.26,1.21-18.81,1.61-28.16Z",
    opacity: 0.2
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M311.43,265.35c.05,4.82-.5,10.09-3.23,14.18,1.45-4.66,1.9-9.46,3.23-14.18Z",
    opacity: 0.2
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M292,294.35c-3,9.47-10.3,17-18,23,6.78-7,13.76-14.13,18-23Z",
    opacity: 0.2
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M289,307.35a12.12,12.12,0,0,1-6,7.73c2-2.61,3.95-5.1,6-7.73Z",
    opacity: 0.2
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M304.27,353.9l-46.73.94-6,.12-19.5.39c3-10,6-12,6-12l13.5.12,6,.06,15.29.14c15.78.32,23.71-1.67,23.71-1.67l3.51-.89a2.81,2.81,0,0,1,3.48,2.38C304.12,348.28,304.27,353.9,304.27,353.9Z",
    fill: "#2b1df7"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M232,355.35s-8,8-2,43l4,15s15-19,62-14c0,0,8-6,22-8,0,0-5.54-29.89-13.77-37.44Z",
    fill: "#2f2e41"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M286.37,343.35c3.83,5.11,4.84,12,4.05,18.19a8.85,8.85,0,0,1-1.22,3.9c-1.43,2-2.34,4.15-1.94,6.32.22,2.52,2.55,4.19,3.1,6.58.76,2.56.51,5.13.3,7.7-.18,3.09.48,5.94,3.06,7.92a7.71,7.71,0,0,1,1.87,5.35,7.93,7.93,0,0,0-2.4-4.78c-6.08-3.84-3-10.08-4.64-15.64a8.71,8.71,0,0,0-1.72-3,8.77,8.77,0,0,1-1.12-8,13.08,13.08,0,0,1,1.89-3.46c1.26-1.91,1.26-4.52,1.52-6.78a27.56,27.56,0,0,0-2.75-14.31Z",
    opacity: 0.2
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M426,621.35s26.41-10.18,36.48-18.69a3,3,0,0,0-.48-4.93c-3-1.64-8.59-2.9-18,.62a9.51,9.51,0,0,1-1.06.28,11.08,11.08,0,0,1-10.56-3.55c-1.28-1.41-3.27-2.89-5.79-2.48l-11.57,7s-.92,4.21,4.53,11Z",
    fill: "#2b1df7"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M390,563.35l25,36.23a4.31,4.31,0,0,0,3.8,1.88,8.88,8.88,0,0,0,7.82-5.07,4.28,4.28,0,0,0-.05-3.79L407,553.35S401,558.35,390,563.35Z",
    fill: "#e6e6e6"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M250,576.35l-16,36a10.12,10.12,0,0,0,12,6s13-26,18-33Z",
    fill: "#e6e6e6"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M227,620.35s4-12,7-8a10.12,10.12,0,0,0,12,6s4,.33,0,10.17c0,0-.79,3.06,4,7.27a30.9,30.9,0,0,1,5.57,6.24c2.85,4.33,5.71,10.64,1.41,14.32l-33.6-24.27a3.21,3.21,0,0,1-.88-4.26Z",
    fill: "#2b1df7"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M327,238v24l8.69-.62s-1.14-15.81,2.59-23.42Z",
    fill: "#f7a48b"
  })), _rect26 || (_rect26 = /*#__PURE__*/React.createElement("rect", {
    x: 609.04,
    y: 488.35,
    width: 175,
    height: 59,
    rx: 9.07,
    fill: "#2f2e41"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M620.61,494.35H694a0,0,0,0,1,0,0v48a0,0,0,0,1,0,0H620.61a6.57,6.57,0,0,1-6.57-6.57V500.93A6.57,6.57,0,0,1,620.61,494.35Z",
    opacity: 0.2
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M703.61,494.35H777a0,0,0,0,1,0,0v48a0,0,0,0,1,0,0H703.61a6.57,6.57,0,0,1-6.57-6.57V500.93A6.57,6.57,0,0,1,703.61,494.35Z",
    transform: "translate(1474.09 1036.71) rotate(180)",
    opacity: 0.2
  })), _rect27 || (_rect27 = /*#__PURE__*/React.createElement("rect", {
    x: 635.04,
    y: 422.35,
    width: 126,
    height: 66,
    rx: 6.35,
    fill: "#2b1df7"
  })), _rect28 || (_rect28 = /*#__PURE__*/React.createElement("rect", {
    x: 639.04,
    y: 501.35,
    width: 31,
    height: 8,
    rx: 4,
    fill: "#fff"
  })), _rect29 || (_rect29 = /*#__PURE__*/React.createElement("rect", {
    x: 724.04,
    y: 501.35,
    width: 31,
    height: 8,
    rx: 4,
    fill: "#fff"
  })), _rect30 || (_rect30 = /*#__PURE__*/React.createElement("rect", {
    x: 642.04,
    y: 443.35,
    width: 37,
    height: 39,
    rx: 4.37,
    opacity: 0.2
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 660.54,
    cy: 462.85,
    r: 14.5,
    fill: "#fff",
    opacity: 0.2
  })), _rect31 || (_rect31 = /*#__PURE__*/React.createElement("rect", {
    x: 719.04,
    y: 444.35,
    width: 37,
    height: 39,
    rx: 4.37,
    opacity: 0.2
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 737.54,
    cy: 463.85,
    r: 14.5,
    fill: "#fff",
    opacity: 0.2
  })), _rect32 || (_rect32 = /*#__PURE__*/React.createElement("rect", {
    x: 643.04,
    y: 428.35,
    width: 74,
    height: 11,
    opacity: 0.2
  })), _rect33 || (_rect33 = /*#__PURE__*/React.createElement("rect", {
    x: 727.04,
    y: 428.35,
    width: 27,
    height: 11,
    opacity: 0.2
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 735.54,
    cy: 433.85,
    r: 3.5,
    fill: "#fff",
    opacity: 0.2
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 745.54,
    cy: 433.85,
    r: 3.5,
    fill: "#fff",
    opacity: 0.2
  })), _rect34 || (_rect34 = /*#__PURE__*/React.createElement("rect", {
    x: 684.04,
    y: 445.35,
    width: 28,
    height: 37,
    opacity: 0.2
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("rect", {
    x: 684.04,
    y: 448.85,
    width: 28,
    height: 1
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("rect", {
    x: 684.04,
    y: 451.85,
    width: 28,
    height: 1
  }))), _rect35 || (_rect35 = /*#__PURE__*/React.createElement("rect", {
    x: 687.04,
    y: 459.35,
    width: 21,
    height: 11,
    fill: "#fff",
    opacity: 0.2
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("rect", {
    x: 684.04,
    y: 475.07,
    width: 28,
    height: 1
  }))), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 248.13,
    cy: 202.8,
    rx: 7.5,
    ry: 5,
    transform: "translate(4.21 410.64) rotate(-79.69)",
    fill: "#f9b499"
  })), _polygon6 || (_polygon6 = /*#__PURE__*/React.createElement("polygon", {
    points: "257.54 343.54 257.54 358.86 251.54 358.86 251.54 343.48 257.54 343.54",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10
  })), _polygon7 || (_polygon7 = /*#__PURE__*/React.createElement("polygon", {
    points: "274.54 343.54 274.54 358.86 268.54 358.86 268.54 343.48 274.54 343.54",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M362.19,475.23C375.71,493.5,382,504.35,382,504.35l25,49c-6,5-17,10-17,10l-21-30c-22-33-37-43-37-43l-51-42c-23-16-42.44-39-42.44-39s17.44-15,57.44-10l61.79,70.48C359.35,471.57,360.81,473.37,362.19,475.23Z",
    fill: "#f9b499"
  })), _ellipse5 || (_ellipse5 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 621.6,
    cy: 221.85,
    rx: 7.44,
    ry: 5.5,
    transform: "translate(151.09 684.7) rotate(-64.17)",
    fill: "#f9b499"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M590.43,239.14s-1,3.43-3.24,8.66a106,106,0,0,1-5.48,10.85c-1.8,3.16-4,9.1,2.42,12.65,0,0,9,5,14-6,0,0,5.7-8.79,8.85-26.4A16,16,0,0,1,590.43,239.14Z",
    fill: "#f9b499"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M590.43,239.14l-1.87,5.27s7.89,4.76,16.73,2.32L607,238.9A16.46,16.46,0,0,1,590.43,239.14Z",
    fill: "#f7a48b"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfessionalDancer);
export default __webpack_public_path__ + "static/media/Professional-Dancer.6589e0ed91268d00164996810536a7ba.svg";
export { ForwardRef as ReactComponent };